<form (ngSubmit)="onSubmit()" #form="ngForm" column-classes="col-md-2,col-md-4,col-md-2,col-md-4">
  <cap-content-header>
    <cap-title>
      {{ "ech0134.grundbuchmeldungen.suche" | translate }}
    </cap-title>
  </cap-content-header>
  <div class="pt-2">
    <cap-form-row column-classes="col-md-2,col-md-4,col-md-2,col-md-4">
      <div class="col-md-2 bsg-label-wrapper">
        <label [attr.for]="'grundbuchmeldungen.empfaenger'" class="bsg-label">
          {{ "ech0134.grundbuchmeldungen.empfaenger" | translate }}
        </label>
      </div>
      <div class="col-md-4 bsg-input-wrapper">
        <div class="input-group">
          <div class="form-control-component">
            <input
              (keydown.tab)="onTab($event)"
              (selectItem)="onSelected($event)"
              [(ngModel)]="model"
              [autofocus]="true"
              [inputFormatter]="inputFormatter"
              [ngbTypeahead]="search"
              [resultFormatter]="resultFormatter"
              #searchInput
              class="form-control"
              name="empfaengerSearch"
              type="search" />
            @if (showNoResultText) {
              <div class="dropdown-menu show dropdown-message">
                <button (click)="onClear()" class="dropdown-item">{{ "search.noResults" | translate }}</button>
              </div>
            }
          </div>
          <button (click)="clearEmpfaengerSearch()" class="btn btn-white" tabindex="-1" type="button">
            <span class="fas fa-times"></span>
          </button>
        </div>
      </div>
    </cap-form-row>
    <cap-form-row column-classes="col-md-2,col-md-4,col-md-2,col-md-4">
      <cap-form-control labelKey="ech0134.grundbuchmeldungen.status">
        <select [(ngModel)]="searchRequest.status" name="erhaeltVertraulicheDaten">
          <option [ngValue]="undefined"></option>
          @for (status of statusEnums(); track status) {
            <option [ngValue]="status">{{ translateStatus(status) }}</option>
          }
        </select>
      </cap-form-control>
    </cap-form-row>
    <cap-form-row column-classes="col-md-2,col-md-4,col-md-2,col-md-4">
      <cap-form-control
        column-classes="col-md-2,col-md-4"
        invalidKey="EingabeMussValidesDatumSeinBeispiel"
        labelKey="ech0134.grundbuchmeldungen.datumVersandVon">
        <cap-datepicker [(ngModel)]="searchRequest.datumVersandVon" name="grundbuchmeldungen.datumVersandVon"></cap-datepicker>
      </cap-form-control>
    </cap-form-row>
    <cap-form-row column-classes="col-md-2,col-md-4,col-md-2,col-md-4">
      <cap-form-control
        column-classes="col-md-2,col-md-4"
        invalidKey="EingabeMussValidesDatumSeinBeispiel"
        labelKey="ech0134.grundbuchmeldungen.datumVersandBis">
        <cap-datepicker [(ngModel)]="searchRequest.datumVersandBis" name="grundbuchmeldungen.datumVersandBis"></cap-datepicker>
      </cap-form-control>
    </cap-form-row>
    <cap-form-row column-classes="col-md-2,col-md-4,col-md-2,col-md-4">
      <cap-tagebuch-nummer
        [(ngModel)]="searchRequest.tagebuchNummer"
        class="col-md-12"
        heading="Grundbuchgeschäft"
        id="grundbuchamtId"
        name="grundbuchamtId"></cap-tagebuch-nummer>
    </cap-form-row>
  </div>
  <cap-bsg-actionbar>
    <button (click)="onReset()" class="btn btn-outline-primary me-2" type="reset">{{ "actionbar.reset" | translate }}</button>
    <button [disabled]="!form.valid" class="btn btn-primary" type="submit">{{ "actionbar.search" | translate }}</button>
  </cap-bsg-actionbar>
</form>
